<template>
  <section class="form-list">
    <el-form
      ref="form"
      :model="teacher"
      label-position="left"
      label-width="160px"
      style="width: 520px; margin-left:50px;"
    >
      <el-form-item label="所属老师">
        <v-avatar-nickname :value="teacher.avatar" :nickname="teacher.nickname"/>
      </el-form-item>
      <el-form-item v-if="isAdministrator" label="所属门店">
        {{ teacher.store_name }}
      </el-form-item>
      <el-form-item label="底薪（元）">
        <v-input-money v-model="teacher.base_pay" class="input"/>
      </el-form-item>

      <template v-if="is_ladder_salary">
        <el-form-item label="成人班课时费（元）">
          <v-input-money v-model="teacher.adult_class_pay" class="input"/>
        </el-form-item>
        <el-form-item label="少儿班课时费（元）">
          <v-input-money v-model="teacher.child_class_pay" class="input"/>
        </el-form-item>
        <el-form-item label="专业班课时费（元）">
          <v-input-money v-model="teacher.major_class_pay" class="input"/>
        </el-form-item>
      </template>
      <el-form-item v-else label="单节大课费用（元）">
        <v-input-money v-model="teacher.class_pay" class="input"/>
      </el-form-item>
      <el-form-item label="单节私教课费用（元）">
        <v-input-money v-model="teacher.private_class_pay" class="input"/>
      </el-form-item>
      <el-form-item label="旷课扣费（元）">
        <v-input-money v-model="teacher.leave_class_pay" class="input"/>
      </el-form-item>


      <el-form-item label="公司社保费用（元）">
        <v-input-money v-model="teacher.social_insurance" class="input"/>
      </el-form-item>
      <el-form-item label="个人社保费用（元）">
        <v-input-money v-model="teacher.personal_insurance" class="input"/>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">立即保存</el-button>
        <el-button @click="RouteConfig.teacherSalaryList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
  import RouteConfig from "@/router/config";
  import { mapGetters } from 'vuex';
  import { show, update } from '@/api/store-teacher';
  import { toYuan, toCent } from '@/filters';

  export default {
    name: RouteConfig.teacherSalaryEdit.name,
    data: () => ({
      RouteConfig,
      isSaving: false,
      is_ladder_salary: false,
      teacher: {
        teacher_id: '',
        store_id: '',
        nickname: '',
        avatar: '',
        base_pay: '',
        class_pay: '',
        private_class_pay: '',
        social_insurance: '',
        personal_insurance: '',
        adult_class_pay: 0,
        child_class_pay: 0,
        major_class_pay: 0,
        leave_class_pay: 0,
      },
    }),
    computed: {
      ...mapGetters([
        'isAdministrator',
      ]),
      id() {
        return +this.$route.params.id || 0;
      },
    },
    beforeMount() {
      this.show();
    },
    methods: {
      async show() {
        const { isError, data } = await show(this.id);
        if (isError) return;

        data.base_pay = toYuan(data.base_pay);
        data.class_pay = toYuan(data.class_pay);
        data.private_class_pay = toYuan(data.private_class_pay);
        data.social_insurance = toYuan(data.social_insurance);
        data.personal_insurance = toYuan(data.personal_insurance);
        data.leave_class_pay = toYuan(data.leave_class_pay);
        data.adult_class_pay = toYuan(data.adult_class_pay);
        data.child_class_pay = toYuan(data.child_class_pay);
        data.major_class_pay = toYuan(data.major_class_pay);
        this.is_ladder_salary = data.is_ladder_salary;
        this.teacher = data;
      },
      handleSubmit() {
        if (this.isSaving) return;

        this.$refs.form.validate(async (isSuccess) => {
          if (!isSuccess) return;

          this.isSaving = true;
          const postData = { ...this.teacher };
          postData.base_pay = toCent(postData.base_pay);
          postData.class_pay = toCent(postData.class_pay);
          postData.private_class_pay = toCent(postData.private_class_pay);
          postData.leave_class_pay = toCent(postData.leave_class_pay);
          postData.social_insurance = toCent(postData.social_insurance);
          postData.personal_insurance = toCent(postData.personal_insurance);

          if (this.is_ladder_salary) {
            postData.adult_class_pay = toCent(postData.adult_class_pay);
            postData.child_class_pay = toCent(postData.child_class_pay);
            postData.major_class_pay = toCent(postData.major_class_pay);
          } else {
            postData.adult_class_pay = 0;
            postData.child_class_pay = 0;
            postData.major_class_pay = 0;
          }

          const {isError} = await update(this.id, postData);
          this.isSaving = false;
          if (isError) return;

          RouteConfig.teacherSalaryList.back();
        });
      },
    },
  };
</script>
